import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/**
 * Тип записів редактора форми за маніфестом пакета, доки визначення модуля ще немає (читання наперед, useCustomizeReads): неосновна
 * сутність із `?type=` (дочірня таблиця), інакше основна; без маніфесту (власний модуль простору) — '' (тип стане відомий з визначення).
 * Чиста функція.
 */
export function manifestFormType(manifest: IModuleManifest | undefined, type: string | null): string {
  const entities = manifest?.entities ?? [];
  return entities.find((e) => e.key === type && !e.main)?.key ?? entities.find((e) => e.main)?.key ?? '';
}
